document.addEventListener('DOMContentLoaded', function() {
  const faqSections = document.querySelectorAll('.gm_faq_block_section');

  faqSections.forEach(section => {
    const accTriggers = section.querySelectorAll('.js-gm-accordion-trigger');

    accTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const thisItem = this.parentElement;
        const items = section.querySelectorAll('.gm-accordion-item');

        items.forEach(item => {
          if (item === thisItem) {
            item.classList.toggle('is-open');
          } else {
            item.classList.remove('is-open');
          }
        });
      });
    });
  });

  document.querySelectorAll('.gm-accordion-content p').forEach(function(p) {
    if (!p.textContent.trim()) {
      p.remove();
    }
  });
});


